import { tourMessages } from './tour.messages';
import { tourTopic } from './tour.topic';
import { MagpieConnection } from 'magpie-lib/connection';
export const runningTourBroadcastSubscriber = onNewRunningTour => {
  return MagpieConnection.get().useTopic(tourTopic).on(tourMessages.runningTourBroadcast.getType(), message => {
    const tourId = message.payload.tourId;
    onNewRunningTour(tourId);
  });
};